import { Flex, Text } from '@chakra-ui/react';
import { IDependentValue } from '@publishing-engine/domain/models';
import { IFetchOrganizationAndJournalsInfo } from 'src/api/queries';

const BetterSuitedForAnotherJournal = ({
  config,
  betterSuitedForAnotherJournal,
  organizationData
}: {
  config: any;
  betterSuitedForAnotherJournal: IDependentValue<string> | null;
  organizationData: IFetchOrganizationAndJournalsInfo;
}) => {
  const title = betterSuitedForAnotherJournal?.exists
    ? config.params.labels.section.title
    : config.params.labels.main;

  return (
    config &&
    betterSuitedForAnotherJournal && (
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingItem">
          {title.replace(
            '{publisherName}',
            organizationData.organization?.name
          )}
        </Text>
        <Text textStyle="textBody">
          {betterSuitedForAnotherJournal?.exists
            ? betterSuitedForAnotherJournal.value
            : config?.params?.labels.options[
                String(betterSuitedForAnotherJournal?.exists)
              ]?.main}
        </Text>
      </Flex>
    )
  );
};

export default BetterSuitedForAnotherJournal;
